<div *ngIf="busy">Fetching data...</div>

<div *ngIf="!busy && userSettings.length > 0">
  Select which Ladder / Level you want to see:
  <br /><br />
  <div *ngFor="let us of userSettings">
    <a href="#" (click)="setLadderLevel($event, us.ladderId, us.levelId)">{{us.ladderName}} - {{us.levelName}}</a>
    <span style="color: white;">{{us.ladderId}} - {{us.levelId}}</span>
    <br />
  </div>
</div>

<div *ngIf="!busy && userSettings.length == 0">
  You are not currently in any ladders.
  <br /><br />
  <a href="#" [routerLink]="['/nextladder']">Join Lubin's Next Ladder</a>
</div>
